import React, { useState, useEffect } from 'react';
import './WinampTOC.css';
import { cleanMarkdownFormatting, createId, countWords } from './utils';

const countWordsInSection = (content, startIndex, level) => {
  const lines = content.split('\n');
  const sectionLines = [];
  let i = startIndex + 1;

  while (i < lines.length) {
    if (lines[i].match(new RegExp(`^#{1,${level}}\\s`))) break;
    sectionLines.push(lines[i]);
    i++;
  }

  return countWords(sectionLines.join('\n'));
};

const WinampTOC = ({ markdownContent }) => {
  const [toc, setToc] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(1);

  const scrollToHeader = (targetId) => {
    const header = document.getElementById(targetId);
    
    if (!header) return;
  
    // Smooth scroll to the header
    header.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'start'
    });
  
    // Add highlight animation class
    header.classList.add('header-highlight');
    
    // Remove highlight after animation
    header.addEventListener('animationend', () => {
      header.classList.remove('header-highlight');
    }, { once: true });
  };

  useEffect(() => {
    function generateTOC() {
      try {
        const lines = markdownContent.split('\n');
        const headers = [];
        let insideCodeBlock = false;

        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          
          if (line.trim().startsWith('```')) {
            insideCodeBlock = !insideCodeBlock;
            continue;
          }

          if (!insideCodeBlock) {
            const headerMatch = line.match(/^(#+)\s+(.*)/);
            
            if (headerMatch) {
              const level = headerMatch[1].length;
              const rawText = headerMatch[2].trim();
              const cleanText = cleanMarkdownFormatting(rawText);
              
              if (level < 4) {
                const words = countWordsInSection(lines.join('\n'), i, level);
                // Use the clean text for ID generation
                const id = createId(cleanText);
                // Use the clean text for display in TOC
                headers.push({ level, text: cleanText, words, id });
              }
            }
          }
        }

        const tocItems = headers.map((header, index) => {
          const isSelected = selectedIndex === index + 1;
          const indent = (header.level - 1) * 2;

          return (
            <a
              key={`${index}-${header.text}`}
              href={`#${header.id}`}
              className={`winamp-playlist-item ${isSelected ? 'selected' : ''}`}
              style={{
                paddingLeft: `${indent}em`
              }}
              onClick={(e) => {
                e.preventDefault();
                setSelectedIndex(index + 1);
                scrollToHeader(header.id);
              }}
            >
              <span className="winamp-item-number">{index + 1}.</span>
              <span className="winamp-item-title">{header.text}</span>
              <span className="winamp-word-count">{header.words}</span>
            </a>
          );
        });

        setToc({ items: tocItems });
      } catch (error) {
        console.error("Error generating TOC:", error);
      }
    }

    generateTOC();
  }, [markdownContent, selectedIndex]);

  return (
    <div className="winamp-container">
      <div className="winamp-title-bar">
        <div className="winamp-yellow-bars-group">
          <div className="winamp-yellow-bar-big" />
          <div className="winamp-yellow-bar-small" />
        </div>
        
        <span className="winamp-title-text">TABLE OF CONTENTS</span>
        
        <div className="winamp-yellow-bars-group">
          <div className="winamp-yellow-bar-big" />
          <div className="winamp-yellow-bar-small" />
        </div>
      </div>
      
      <div className="winamp-playlist">
        {toc?.items}
      </div>
    </div>
  );
};

export default WinampTOC;